'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Photo = void 0;
const $ = require("jquery");
class Photo {
    constructor() {
        // データ変更
        $('.trigPhotoImage').on('click', (e) => {
            // 初期位置にリセット
            $('.bulletScrollPhoto').attr('data-view', 'thumbnail');
            //
            const photo_id = $(e.currentTarget).attr('data-photo-id');
            $('.bulletPhotoNumber').attr('data-photo-id', photo_id);
            setTimeout(() => {
                const image = $(e.currentTarget).attr('data-image');
                const name = $(e.currentTarget).attr('data-name');
                $('.bulletPhotoImage').attr('src', image);
                $('.bulletPhotoBackgroundImage').css({ 'background-image': `url(${image})` });
                $('.bulletPhotoName').html(name);
                $('.bulletShowZoom').fadeIn('slow');
            }, 200);
        });
        // モーダル閉じる
        $('.trigHideZoom').on('click', (e) => {
            $('.bulletShowZoom').fadeOut('slow');
        });
        // 表紙表示
        $('.trigPreviewCover').on('click', () => {
            $('.bulletScrollPhoto').attr('data-view', 'cover');
        });
        // サムネイル表示
        $('.trigPreviewThumbnail').on('click', () => {
            $('.bulletScrollPhoto').attr('data-view', 'thumbnail');
        });
        // 完了画面閉じる
        $('.trigThankYou').on('click', (e) => {
            $(e.currentTarget).fadeOut('slow');
        });
        // 投票システム
    }
}
exports.Photo = Photo;
exports.default = Photo;
